export default __webpack_public_path__ + "static/media/minha-vaidade.216fef16.jpg";